import { TipoLocalitaEstera1 } from 'server/schema/integrations/pdnd/schema/schemas';

export function getCitizenForeignAddressCity(
  foreignLocation?: TipoLocalitaEstera1
): string | undefined {
  const localita = foreignLocation?.indirizzoEstero?.localita;
  if (!localita) return undefined;

  return (
    (localita?.descrizioneLocalita ?? '') +
    ', ' +
    (localita?.descrizioneStato ?? '') +
    ' ' +
    // localita?.codiceStato ?? ''  +
    // ' ' +
    (localita?.provinciaContea ?? '')
  );
}
